import React, { useMemo } from 'react'
import { Flex, Text } from '@leverege/ui-elements'
import { Attributes } from '@leverege/ui-attributes'
import MoldHalfCard from './MoldHalfCard'
import S from './LineCard.css'
import LinePill from './LinePill'

const isNullOrNaN = ( n ) => {
  return n == null || Number.isNaN( n )
}

function createMoldHalfObjRef( item, parent, delegate ) {
  if ( !item ) {
    return null
  }
  return {
    id : item.id,
    data : item,
    type : 'moldHalf',
    ref : delegate?.item( parent.id ).getInterfaceUrl()
  }
}

const WAY_BELOW_THRESHOLD = 3
const getWorkerCountStatus = ( { assigned, count } ) => {
  if ( assigned === count ) return 'match'
  if ( assigned - count > WAY_BELOW_THRESHOLD ) return 'wayBelow'
  if ( count < assigned ) return 'below'
  if ( count > assigned ) return 'above'

  return null
}

function LineCard( props ) {
  const {
    line,
    delegate
  } = props

  const name = Attributes.get( 'name', line )
  
  const { uw, lw } = useMemo( () => {
    const uw = line.data?.data?.uwMold
    const lw = line.data?.data?.lwMold

    return {
      uw : createMoldHalfObjRef( uw, line, delegate ),
      lw : createMoldHalfObjRef( lw, line, delegate )
    }
  }, [ line, delegate ] )

  const nWorkersAssigned = Attributes.get( 'mold.workersAssigned', line )
  const nWorkersOnLine = ( uw?.data?.data?.workerCountOnMold ?? 0 ) + ( lw?.data?.data?.workerCountOnMold ?? 0 )
  const workerCountStatus = getWorkerCountStatus( { assigned : nWorkersAssigned, count : nWorkersOnLine } )

  return (
    <div className={S.container}>
      <Text
        iconOpts={{ style : { fontWeight : 400, fontSize : '19px' } }}
        variant="lineDetailTitle|detailTitle"
        className={S.header}>
        {name}
      </Text>
      <Flex className={S.body} variant="colM">
        <Flex variant="rowM">
          <MoldHalfCard half={uw} name="HP" />
          <MoldHalfCard half={lw} name="LP" />
        </Flex>
        <Flex variant="colM" className={S.footerCard}>
          <Flex variant="rowSpaceBetween">
            <Text variant="lineDetailLabel">Total Workers Assigned To Line</Text>
            {!isNullOrNaN( nWorkersAssigned ) ? <LinePill number={nWorkersAssigned} status="assigned" /> : '-'}
          </Flex>
          <Flex variant="rowSpaceBetween">
            <Text variant="lineDetailLabel">Total Workers Currently On Line</Text>
            {!isNullOrNaN( nWorkersOnLine ) ? <LinePill number={nWorkersOnLine} status={workerCountStatus} /> : '-'}
          </Flex>
        </Flex>
      </Flex>
    </div>
  )
}

export default LineCard
